export default __webpack_public_path__ + "static/media/MF_full_web.bb29b820.png";